module.exports = __webpack_public_path__ + "./assets/img_osakaShinsaibashi_color@2x__6f5e05b9785b77e5248aea5e0a3b3975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_osakaShinsaibashi_color@2x.jpg
// module id = 631
// module chunks = 12